/* KLAXON premium mobile drawer interaction. Scoped to <=840px and leaves desktop navigation unchanged. */
(()=>{
  const header=document.querySelector('[data-klx-header]');
  if(!header||header.dataset.klxDrawerEnhanced==='true')return;

  const toggle=header.querySelector('[data-klx-mobile-toggle]');
  const drawer=header.querySelector('[data-klx-mobile-drawer]');
  const closeBtn=header.querySelector('[data-klx-mobile-close]');
  const backdrop=header.querySelector('[data-klx-mobile-backdrop]');
  if(!toggle||!drawer||!closeBtn||!backdrop)return;

  header.dataset.klxDrawerEnhanced='true';
  const mq=window.matchMedia('(max-width: 840px)');
  const navItems=[...drawer.querySelectorAll('[data-klx-nav-item]')];
  const searchPanel=document.querySelector('[data-klx-search-results]');
  const searchInput=document.querySelector('[data-klx-search-input]');
  let lastFocused=null;
  let syncing=false;

  const syncSubmenus=()=>{
    navItems.forEach(item=>{
      const trigger=item.querySelector('[data-klx-nav-trigger]');
      const mega=item.querySelector('.klx-mega');
      const open=item.classList.contains('is-open');
      if(trigger)trigger.setAttribute('aria-expanded',String(open));
      if(mega){
        mega.setAttribute('aria-hidden',String(!open));
        if('inert' in mega)mega.inert=!open;
      }
    });
  };

  const closeSubmenus=(except=null)=>{
    navItems.forEach(item=>{
      if(item===except)return;
      item.classList.remove('is-open');
    });
    syncSubmenus();
  };

  const unlockPage=()=>{
    document.documentElement.classList.remove('klx-menu-open');
    document.body.classList.remove('klx-menu-open');
  };

  const lockPage=()=>{
    document.documentElement.classList.add('klx-menu-open');
    document.body.classList.add('klx-menu-open');
  };

  const setMenu=(open,{returnFocus=false}={})=>{
    if(!mq.matches&&open)return;
    syncing=true;
    header.classList.toggle('is-menu-open',open);
    toggle.setAttribute('aria-expanded',String(open));
    backdrop.setAttribute('aria-hidden',String(!open));

    if(open){
      lastFocused=document.activeElement;
      lockPage();
      closeSubmenus();
      if(searchPanel)searchPanel.hidden=true;
      if(searchInput)searchInput.setAttribute('aria-expanded','false');
      window.setTimeout(()=>closeBtn.focus({preventScroll:true}),45);
    }else{
      unlockPage();
      closeSubmenus();
      if(returnFocus){
        const target=lastFocused&&typeof lastFocused.focus==='function'?lastFocused:toggle;
        window.setTimeout(()=>target.focus({preventScroll:true}),25);
      }
    }
    syncing=false;
  };

  /* Capture the hamburger before the older theme listener so it toggles only once. */
  toggle.addEventListener('click',event=>{
    if(!mq.matches)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    setMenu(!header.classList.contains('is-menu-open'));
  },true);

  closeBtn.addEventListener('click',event=>{
    event.preventDefault();
    setMenu(false,{returnFocus:true});
  });

  backdrop.addEventListener('click',event=>{
    event.preventDefault();
    setMenu(false,{returnFocus:true});
  });

  /* Mobile accordion: capture before the desktop/legacy dropdown listener for smooth, predictable state. */
  drawer.addEventListener('click',event=>{
    if(!mq.matches)return;
    const trigger=event.target.closest('[data-klx-nav-trigger]');
    if(trigger&&drawer.contains(trigger)){
      event.preventDefault();
      event.stopImmediatePropagation();
      const item=trigger.closest('[data-klx-nav-item]');
      if(!item)return;
      const willOpen=!item.classList.contains('is-open');
      closeSubmenus(item);
      item.classList.toggle('is-open',willOpen);
      syncSubmenus();
      return;
    }

    const link=event.target.closest('a[href]');
    if(link&&drawer.contains(link))setMenu(false);
  },true);

  document.addEventListener('keydown',event=>{
    const open=header.classList.contains('is-menu-open')||document.documentElement.classList.contains('klx-menu-open');
    if(!mq.matches||!open)return;

    if(event.key==='Escape'){
      event.preventDefault();
      setMenu(false,{returnFocus:true});
      return;
    }

    if(event.key==='Tab'){
      const focusables=[...drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')]
        .filter(el=>!el.closest('[aria-hidden="true"]')&&el.getClientRects().length>0);
      if(!focusables.length)return;
      const first=focusables[0];
      const last=focusables[focusables.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    }
  },true);

  const resetForDesktop=()=>{
    if(!mq.matches){
      header.classList.remove('is-menu-open');
      toggle.setAttribute('aria-expanded','false');
      backdrop.setAttribute('aria-hidden','true');
      unlockPage();
      navItems.forEach(item=>{
        const mega=item.querySelector('.klx-mega');
        if(mega){
          mega.removeAttribute('aria-hidden');
          if('inert' in mega)mega.inert=false;
        }
      });
    }else{
      syncSubmenus();
    }
  };

  if(mq.addEventListener)mq.addEventListener('change',resetForDesktop);
  else if(mq.addListener)mq.addListener(resetForDesktop);

  /* If legacy code removes the menu class (for example on Escape/outside tap), also release scroll lock. */
  new MutationObserver(()=>{
    if(syncing)return;
    const open=header.classList.contains('is-menu-open');
    toggle.setAttribute('aria-expanded',String(open));
    backdrop.setAttribute('aria-hidden',String(!open));
    if(open&&mq.matches)lockPage();
    else unlockPage();
  }).observe(header,{attributes:true,attributeFilter:['class']});

  resetForDesktop();
})();
